import type { FC } from "react"

import { ConfirmationDialog } from "@/components/common/Modals"
import { GoodsReceiptPalletDeleteScenario } from "@/screens/WarehouseReceiving/types"

const DELETE_SCENARIO_TO_MESSAGE: Record<GoodsReceiptPalletDeleteScenario, string> = {
  [GoodsReceiptPalletDeleteScenario.Standard]: "Deleting the pallet will remove this from inventory permanently.",
  [GoodsReceiptPalletDeleteScenario.Last]:
    "This is the last pallet on the work order. Deleting it will also delete the GR. If more pallets are going to be added, please add a new pallet before deleting this one.",
  [GoodsReceiptPalletDeleteScenario.LastNonStored]:
    "This is the last pallet on the work order. Deleting it will mark the GR as Stored, and you will not be able to add any new pallets. If more pallets are going to be added, please add a new pallet before deleting this one.",
}

interface GoodsReceiptPalletDeleteConfirmationProps {
  scenario: GoodsReceiptPalletDeleteScenario
  onClose: () => void
  onConfirm: () => void | Promise<void>
}

export const GoodsReceiptPalletDeleteConfirmation: FC<GoodsReceiptPalletDeleteConfirmationProps> = ({
  scenario,
  onClose,
  onConfirm,
}) => {
  return (
    <ConfirmationDialog
      title='Are you sure you want to delete the pallet?'
      content={DELETE_SCENARIO_TO_MESSAGE[scenario]}
      closeLabel='Cancel'
      confirmLabel='Delete'
      onClose={onClose}
      onConfirm={onConfirm}
      isWarning
    />
  )
}
